import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { REQUEST_COLORS } from "components/Table/styles";
import { PapsServiceColor } from "config/status";
import { COLORS  } from "constants/colors";
import { PapsService } from "generated/graphql";

interface StyleProps {
  color?: string;
}
export const useParcelStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    rootParcel: {
      marginRight: 10,
      marginTop: -25,
      [theme.breakpoints.down("xs")]: {
        marginTop: -12,
      },
    },
    center: {
      flex: 1,
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      marginTop: 10,
    },
    navcontainer: {
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column-reverse",
      },
    },
    nav: {
      flex: 1,
      marginTop: "11px",
      [theme.breakpoints.down("xs")]: {
        marginTop: 10,
        marginLeft: "-32px",
        marginRight: "0px",
        width: "101vw",
      },
    },
    ant: {
      flex: 2,
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      color: COLORS.primary,
      fontFamily: "Montserrat",
      marginLeft: "auto",
      fontSize: "13px",
      fontWeight: 600,
      [theme.breakpoints.down("xs")]: {
        marginTop: 10,
        marginRight: "287px",
      },
    },
    switch: {
      [theme.breakpoints.down("xs")]: { fontSize: 11, width: "max-content" },
    },
    bottom: {
      height: "100%",
      [theme.breakpoints.down("xs")]: {
        marginLeft: -18,
        overflowX: "scroll",
      },
    },
    search: {
      "& .MuiInputBase-input": {
        height: "1rem",
      },
      [theme.breakpoints.down("xs")]: {
        "& .MuiInputBase-input": {
          width: "40vw",
          height: 3,
        },
      },
    },
    slogan: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-evenly",
      padding: 20,
      paddingLeft: 60,
    },

    countTotal: {
      "& .MuiTablePagination-caption": {
        display: "flex",
      },
      "& .MuiTablePagination-actions": {
        color: COLORS.primary,
      },
      "& .MuiTablePagination-input": {
        color: COLORS.primary,
      },
      "& .MuiSelect-icon": {
        color: COLORS.primary,
      },
      "& .MuiSelect-select.MuiSelect-select": {
        border: "solid 0.5px",
        borderRadius: "4px",
      },
    },
    badge: {
      marginBottom: "auto",
      marginTop: -3,
    },
    table: {
      display: "grid",
      marginLeft: "-19px",
      " & .MuiTableRow-head": {
        "& .MuiTableCell-head:first-child": {
          paddingLeft: "20px",
          borderBottomLeftRadius: "5px",
          borderTopLeftRadius: "5px",
        },
        "& .MuiTableCell-head:nth-last-child": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
        },
        "& .MuiTableCell-head:last-child": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
          border: "none",
        },
      },
      " & .MuiTableRow-root": {
        "& > td": {
          paddingBottom: "6px",
          paddingTop: "6px",
          borderTop: "1px solid rgba(64, 180, 229, 0.25)",
          borderBottom: "1px solid rgba(64, 180, 229, 0.25)",
        },
        "& .MuiTableCell-root:first-child": {
          borderRadius: "10px 0px 0px 10px",
          borderLeft: ({ color }: StyleProps) => (color ? `4px solid ${REQUEST_COLORS[color]} !important` : "none"),
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "1px solid rgba(64, 180, 229, 0.25)",
        },
      },
      "& .MuiTableCell-head": {
        marginBottom: "1em",
        height: "50px",
        backgroundColor: COLORS.lightBlue,
        color: COLORS.primary,
      },
      "& .MuiTableRow-head .MuiTableCell-head:first-child": {
        border: "none !important",
      },
      "& .MuiTableRow-root": {
        height: 30,
      },
      [theme.breakpoints.down("xs")]: {
        marginLeft: -31,
      },
    },
    root: {
      marginRight: 10,
      [theme.breakpoints.down("xs")]: {
        margin: "center",
      },
    },
  })
);
